module.exports = __webpack_public_path__ + "static/getStarted_refresher_mobile-3f7f355536acd6b776d95d7f71512ea8.svg";